export default __webpack_public_path__ + "static/media/Eye_1_M_C5.d0eb3159.svg";